import React, { PureComponent } from "react";
import { Editor } from "react-draft-wysiwyg";
import styles from "./styles.module.scss";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class EditorComponent extends PureComponent {
  toolbarOptions = {
    options: [
      "history",
      "inline",
      "blockType",
      "fontSize",
      "colorPicker",
      "textAlign",
      "list",
      "remove",
    ],
  };

  render() {
    const { editorState, onChangeEditorState } = this.props;

    return (
      <Editor
        editorState={editorState}
        toolbarClassName={styles.toolbar}
        wrapperClassName={styles.wrapper}
        editorClassName={styles.editor}
        onEditorStateChange={onChangeEditorState}
        toolbar={this.toolbarOptions}
      />
    );
  }
}

export default EditorComponent;
